<template>
  <v-chip v-if="accountCredit > 0" pill color="primary">Credit Amount ${{ accountCredit.toFixed(2) }}</v-chip>
</template>
<script>
import { dataService, errorMessageMixin } from "../shared";

export default {
  name: "AccountCreditChip",
  async created() {
    await this.loadAccountCredit(this.$store.state.account.id);
  },
  mixins: [errorMessageMixin],
  data() {
    return {
      accountCredit: 0
    }
  },
  methods: {
    async loadAccountCredit(id) {
      try {
        this.accountCredit = await dataService.getAccountCredit(
          id,
          this.$store.state.token
        );
        console.log("accountCredit", this.accountCredit);
        this.$emit('getAccountCredit', this.accountCredit);
      } catch (err) {
        console.log("in the account chip err", err);
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
    }
  }
}
</script>